import { createLogger } from "../../../utils";
import { formatAdMetadata } from "../../meta-api";
import requestArticleMetadata from "../../meta-api/article-meta";
import getBrowserSegments from "./segments/dmp-segments";
const logger = createLogger("Targeting parameters");
async function resolveTargetingParams(targetingConfig, context, contextualLimits) {
    let syncKvs = [];
    let asyncKvs = [];
    logger.logInfo(`Trying to figure out targeting config`);
    if (typeof targetingConfig === "function") {
        logger.logInfo(`Found a function for targeting, awaiting it`);
        syncKvs = await targetingConfig(context);
    }
    else if ("syncKvs" in targetingConfig &&
        typeof targetingConfig.syncKvs === "function") {
        logger.logInfo(`Found sync kvs in targeting object`);
        syncKvs = targetingConfig.syncKvs(context);
    }
    if (Array.isArray(targetingConfig)) {
        logger.logInfo(`Found an array of kvs resolvers`);
        asyncKvs = targetingConfig;
    }
    else if ("asyncKvs" in targetingConfig) {
        if (Array.isArray(targetingConfig.asyncKvs)) {
            logger.logInfo(`Found an array of kvs resolvers in targeting object`);
            asyncKvs = targetingConfig.asyncKvs;
        }
        else if (typeof targetingConfig.asyncKvs === "function") {
            logger.logInfo(`Found a function in targeting object, awaiting it`);
            const resolved = await targetingConfig.asyncKvs(context);
            logger.logInfo(`Merge results to sync`);
            syncKvs = [...syncKvs, ...resolved];
        }
    }
    let params = {};
    let resolved = [];
    if (asyncKvs.length > 0) {
        logger.logInfo(`Starting to resolve ${asyncKvs.length} async ad targeting params...`);
        resolved = await Promise.all([
            ...asyncKvs.map((atp) => atp.getValue(context)),
        ]);
        logger.logInfo(`Async params resolved`);
    }
    logger.logInfo(`Merge sync kvs`);
    params = [...syncKvs, ...resolved].reduce((kvs, kv) => {
        const kvObj = { ...kvs };
        kvObj[kv.key] = kv.value;
        return kvObj;
    }, {});
    logger.logInfo(`Kvs: ${JSON.stringify(params, null, 2)}`);
    logger.logInfo(`Requesting metadata`);
    const meta = await requestArticleMetadata(context);
    if (!contextualLimits) {
        logger.logWarn(`Missing contextual limits`);
    }
    if (meta && contextualLimits) {
        logger.logInfo(`Received metadata, formatting`);
        params = {
            ...params,
            ...formatAdMetadata(meta, contextualLimits),
        };
    }
    else {
        logger.logInfo(`Did not get meta data`);
    }
    logger.logInfo(`Resolving Send to Site`);
    const browserSegments = getBrowserSegments();
    logger.logInfo(`Browsersegments: ${JSON.stringify(browserSegments, null, 2)}`);
    params = { ...params, ...browserSegments };
    logger.logInfo(`Ad targeting params resolved!`);
    return params;
}
function resolveTargetingParamsSync(targetingConfig, context) {
    let syncKvs = [];
    let asyncKvs = [];
    if (typeof targetingConfig === "function") {
        const kvs = targetingConfig(context);
        if (!(kvs instanceof Promise)) {
            syncKvs = kvs;
        }
    }
    else if ("syncKvs" in targetingConfig &&
        typeof targetingConfig.syncKvs === "function") {
        syncKvs = targetingConfig.syncKvs(context);
    }
    else {
        syncKvs = [];
    }
    if (Array.isArray(targetingConfig)) {
        asyncKvs = targetingConfig;
    }
    else if ("asyncKvs" in targetingConfig) {
        if (Array.isArray(targetingConfig.asyncKvs)) {
            asyncKvs = targetingConfig.asyncKvs;
        }
    }
    let params = {};
    logger.logInfo(`Shim any sync values from async params...`);
    params = [...syncKvs, ...asyncKvs].reduce((kvs, p) => {
        if ("getValue" in p) {
            const val = p.getValue(context);
            if (!(val instanceof Promise)) {
                const v = val;
                return { ...kvs, [v.key]: [v.value] };
            }
            return kvs;
        }
        if ("value" in p) {
            return { ...kvs, [p.key]: [p.value] };
        }
        return kvs;
    }, {});
    logger.logInfo(`Kvs resolved`);
    logger.logInfo(`Kvs: ${JSON.stringify(params, null, 2)}`);
    logger.logInfo(`Resolving Send to Site`);
    const browserSegments = getBrowserSegments();
    logger.logInfo(`Browsersegments: ${JSON.stringify(browserSegments, null, 2)}`);
    params = { ...params, ...browserSegments };
    logger.logInfo(`Ad targeting params resolved! (sync)`);
    return params;
}
export { resolveTargetingParams, resolveTargetingParamsSync };
//# sourceMappingURL=targeting-params.js.map